<template>
  <Card :name="config.variableFullName" >
    <template v-slot:header >
      <h5 class="card-category pull-right">
        {{ getTimeAgo((nowTime - time) / 1000) }}
      </h5>
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>
    </template>

    <h2>
      <i
        class="fa"
        :class="[config.icon, getIconColorClass()]"
        style="font-size: 30px"
      ></i>
      {{ value.toFixed(config.decimalPlaces) }} {{ config.unit }}
    </h2>
  </Card>
</template>

<script>
import emmiter from "@/eventBus";
export default {
  props: ["config"],
  data() {
    return {
      value: 0,
      topic: "",
      time: Date.now(),
      nowTime: Date.now(),
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.value = 0;

          // this.$nuxt.$off(this.topic + "/sdata");
          emmiter.off(this.topic + "/sdata");

          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }
          //userId/dId/uniquestr/sdata
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;
          // this.$nuxt.$on(this.topic + "/sdata", this.processReceivedData);
          emmiter.on(this.topic + "/sdata", this.processReceivedData);
        }, 300);
      },
    },
  },
  mounted() {
    this.getNow();
  },
  beforeDestroy() {
    // this.$nuxt.$off(this.topic + "/sdata");
    emmiter.off(this.topic + "/sdata");
  },
  methods: {
    getNow() {
      this.nowTime = Date.now();
      setTimeout(() => {
        this.getNow();
      }, 1000);
    },
    getTimeAgo(seconds) {
      if (seconds < 0) {
        seconds = 0;
      }

      if (seconds < 59) {
        return seconds.toFixed() + " secs";
      }

      if (seconds > 59 && seconds <= 3600) {
        seconds = seconds / 60;
        return seconds.toFixed() + " min";
      }

      if (seconds > 3600 && seconds <= 86400) {
        seconds = seconds / 3600;
        return seconds.toFixed() + " hour";
      }

      if (seconds > 86400) {
        seconds = seconds / 86400;
        return seconds.toFixed() + " day";
      }
    },

    getIconColorClass() {
      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },

    processReceivedData(data) {
      try {
        //console.log("received");
        //console.log(data);
        this.time = Date.now();
        this.value = data.value;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
